import script from "./ModalPhoneVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPhoneVerification.vue?vue&type=script&setup=true&lang=js"

import "./ModalPhoneVerification.vue?vue&type=style&index=0&id=2fd52bd3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd52bd3"]])

export default __exports__